import Button from 'react-bootstrap/Button';
import ButtonDeprecated from './deprecated';

Button.Deprecated = ButtonDeprecated;

export default Button;
